import styled from 'styled-components';
import hexOpacity from 'hex-opacity';
import FONTS from 'constants/fonts';

const StyledInstructionItem = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;

  /* The last child is a scroll bottom view anchor */
  :nth-last-child(2) {
    margin-bottom: 0px;
  }
`;

interface BadgeProps {
  badgeColor: string;
  showBackground: boolean;
}

const Badge = styled.span<BadgeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-right: 16px;

  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
  font-size: ${FONTS.H5};

  background-color: ${(props) =>
    props.showBackground
      ? hexOpacity.create(props.badgeColor, 0.2)
      : 'transparent'};
`;

const TextBlock = styled.div`
  margin: 0;
  flex: 1;
  font-size: 14px;
  line-height: 24px;
  strong {
    font-weight: 500;
  }
`;

interface InstructionItemProps {
  index?: number;
  badgeColor: string;
  icon?: React.ReactNode;
  showBadgeBackground?: boolean;
  children: React.ReactNode;
}

const InstructionItem = ({
  index,
  badgeColor,
  icon,
  showBadgeBackground = !icon,
  children,
}: InstructionItemProps) => (
  <StyledInstructionItem>
    <Badge badgeColor={badgeColor} showBackground={showBadgeBackground}>
      {icon || index}
    </Badge>
    <TextBlock>{children}</TextBlock>
  </StyledInstructionItem>
);

export default InstructionItem;
